import styled from 'styled-components';
import { Modal } from "react-bootstrap";
import { Form } from "formik";
import { RiSearch2Line } from 'react-icons/ri';

export const HDivider= styled.div`
    width: 100%;
    height: 1px;
    background-color: #C6C6C6;
`;

export const VDivider = styled.div`
	width: 1px;
  height: ${(props) => props.h ? props.h : '5rem'};
	background-color: #C6C6C6;
`;

export const Card = styled.div`
	background-color: white;
	border-radius: ${(prop) => prop.borderRadius ? prop.borderRadius : '8px'};
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	padding: ${(prop) => prop.cardPadding ? prop.cardPadding : '1rem'};
	width: 100%;
	height: ${(prop) => prop.cardHeight ? prop.cardHeight : 'inherit'};
	margin-top: ${(prop) => prop.mTop ? prop.mTop : '0px'};
	margin-left: ${(prop) => prop.mLeft ? prop.mLeft : '0px'};
	margin-right: ${(prop) => prop.mRight ? prop.mRight : '0px'};
`;

export const EmptyLabel = styled.div`
	color: #C6C6C6;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	height: 10rem;
`;

export const ModalHolder = styled(Modal)`
  font-family: "YEKAN-BAKH-MEDIUM";
`;

export const ModalHeader = styled.div`
  font-size: 18pt;
  width: 100%;
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const FormHolder = styled(Form)`
  direction: rtl;
`;

export const CloseButton = styled.div`
  background-color: #424250;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  top: 12px;
  right: 10px;
`;

export const ForgotButton = styled.button`
	width: 100%;
	font-size: 10pt;
	background-color: transparent;
	color: #0047ff;
	border: none;
	outline: 0;
	text-align: right;
	box-shadow: none;

	&:focus {
		border: none !important;
		outline: 0 !important;
		box-shadow: none !important;
		background-color: transparent;
	}
	&:hover {
		background-color: transparent;
	}
`;

export const OneLineLabel = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
`

export const CommonSearchButton = styled(RiSearch2Line).attrs({ size: '22px', color: 'black' })`
	cursor: pointer;
`;